module.exports = __webpack_public_path__ + "static/img/3.5322e94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/3.png
// module id = H9am
// module chunks = 0